'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://www.kirupa.com/react/transferring_properties.htm
// http://stackoverflow.com/questions/36631761/when-should-i-add-redux-to-a-react-app
var Module3Res5 = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module3Res5, _Component);

  function Module3Res5() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module3Res5);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module3Res5.__proto__ || (0, _getPrototypeOf2.default)(Module3Res5)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      module: 'Module 3',
      title: 'Providing Praise'
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Module3Res5, [{
    key: 'render',
    value: function render() {
      var styles = require('../Resources.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 12, sm: 12, xs: 12, lg: 12 },
          _react2.default.createElement(
            'div',
            { className: styles.activityPanel },
            _react2.default.createElement(
              'div',
              { className: styles.title },
              _react2.default.createElement(
                'h3',
                null,
                this.state.module
              ),
              _react2.default.createElement(
                'h2',
                null,
                this.state.title
              )
            ),
            _react2.default.createElement(
              ReactBootstrap.Row,
              null,
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 12, xs: 12, sm: 12 },
                _react2.default.createElement(
                  'p',
                  null,
                  'Praise can be powerful and can strengthen behaviours that you want to encourage in your child. It is natural to notice and respond to moments when your child does something wrong. However, we often forget to notice and respond to children when they do something right.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Try to look for times when your child is displaying a good behaviour and praise them for it. Explain clearly why you are encouraging them as it\'s not always obvious for children, especially where eating is concerned. Of course, you don\'t need to praise your child every time they do the right thing. Other ways you can provide positive reinforcement are to smile and speak witha happy voice.'
                ),
                _react2.default.createElement(
                  'h3',
                  null,
                  'Ways to praise'
                ),
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      'Thanks for doing as I asked. You\'ve been so helpful to me!'
                    )
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      'Marvellous work. You did a fantastic job of washing the carrots.'
                    )
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      'That was a terrific job. You were very good at trying a new food.'
                    )
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      'That was great seeing you come to the table when I asked.'
                    )
                  )
                ),
                _react2.default.createElement(
                  'h3',
                  null,
                  'Rewards'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'When children do lots of good things, sometimes you might want to provide a reward to encourage more good behaviour. It is often easy to use unhealthy food as a reward. When possible, try to avoid using food as rewards. This sends a message to children that unhealthy foods are better and more desirable than healthy foods. So what other rewards are there? How about these ideas...'
                ),
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      'A cuddle with Mum or Dad'
                    )
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      'Playing with favourite toy or pet'
                    )
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      'Reading a story together'
                    )
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      'Playing outside'
                    )
                  )
                )
              )
            ),
            _react2.default.createElement('div', { className: styles.spacer40 })
          )
        )
      );
    }
  }]);
  return Module3Res5;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object
}, _temp2)) || _class);
exports.default = Module3Res5;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Resources/3/Res5.js
// module id = 1251
// module chunks = 0